module.exports = __webpack_public_path__ + "img/11_BC12_tell_tales.316d21e9.jpg";